import { useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { usePairingDialog } from '@/stores/pairing'
import { PairingFlow } from './pairing-flow'

/** Global pairing dialog — open with `usePairingDialog.getState().show(preset)`. */
export function PairingDialog() {
  const { open, preset, session, close } = usePairingDialog()
  const [title, setTitle] = useState('Pair a player')
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>Connect a Signetix player to your organization.</DialogDescription>
        </DialogHeader>
        {open && <PairingFlow key={session} preset={preset} onCancel={close} onDone={close} onTitleChange={setTitle} />}
      </DialogContent>
    </Dialog>
  )
}
